export default {"src":"/_next/static/media/chat.8f6141ec.svg","height":94,"width":89,"blurWidth":0,"blurHeight":0};